import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Alert } from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import api from '../../services/api';

const FoerdergeberPage = () => {
  const [foerdergeber, setFoerdergeber] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '', kurzname: '', anschrift: '', ansprechperson: '', email: '', telefon: '', website: '' });

  const load = async () => {
    try {
      const res = await api.get('/foerdergeber');
      setFoerdergeber(res.data);
    } catch (err) { setError('Fehler beim Laden'); }
  };

  useEffect(() => { load(); }, []);

  const handleOpen = (fg = null) => {
    if (fg) {
      setEditing(fg);
      setForm({ name: fg.name || '', kurzname: fg.kurzname || '', anschrift: fg.anschrift || '',
        ansprechperson: fg.ansprechperson || '', email: fg.email || '', telefon: fg.telefon || '', website: fg.website || '' });
    } else {
      setEditing(null);
      setForm({ name: '', kurzname: '', anschrift: '', ansprechperson: '', email: '', telefon: '', website: '' });
    }
    setOpen(true);
  };

  const handleSave = async () => {
    try {
      if (editing) {
        await api.put(`/foerdergeber/${editing.id}`, form);
      } else {
        await api.post('/foerdergeber', form);
      }
      setOpen(false);
      load();
    } catch (err) { setError('Fehler beim Speichern'); }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Wirklich l\u00f6schen?')) {
      try {
        await api.delete(`/foerdergeber/${id}`);
        load();
      } catch (err) { setError('Fehler beim L\u00f6schen'); }
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" fontWeight="bold" color="#1B5E20">F\u00f6rdergeber</Typography>
        <Button variant="contained" startIcon={<Add />} onClick={() => handleOpen()}
          sx={{ bgcolor: '#1B5E20', '&:hover': { bgcolor: '#2E7D32' } }}>
          Neuer F\u00f6rdergeber
        </Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: '#E8F5E9' }}>
              <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Kurzname</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Ansprechperson</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>E-Mail</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="right">Aktionen</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {foerdergeber.length === 0 ? (
              <TableRow><TableCell colSpan={5} align="center" sx={{ py: 4, color: '#999' }}>Noch keine F\u00f6rdergeber angelegt</TableCell></TableRow>
            ) : foerdergeber.map((fg) => (
              <TableRow key={fg.id} hover>
                <TableCell>{fg.name}</TableCell>
                <TableCell>{fg.kurzname}</TableCell>
                <TableCell>{fg.ansprechperson}</TableCell>
                <TableCell>{fg.email}</TableCell>
                <TableCell align="right">
                  <IconButton size="small" onClick={() => handleOpen(fg)}><Edit /></IconButton>
                  <IconButton size="small" color="error" onClick={() => handleDelete(fg.id)}><Delete /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editing ? 'F\u00f6rdergeber bearbeiten' : 'Neuer F\u00f6rdergeber'}</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Name *" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} margin="normal" />
          <TextField fullWidth label="Kurzname" value={form.kurzname} onChange={(e) => setForm({...form, kurzname: e.target.value})} margin="normal" />
          <TextField fullWidth label="Ansprechperson" value={form.ansprechperson} onChange={(e) => setForm({...form, ansprechperson: e.target.value})} margin="normal" />
          <TextField fullWidth label="E-Mail" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} margin="normal" />
          <TextField fullWidth label="Telefon" value={form.telefon} onChange={(e) => setForm({...form, telefon: e.target.value})} margin="normal" />
          <TextField fullWidth label="Website" value={form.website} onChange={(e) => setForm({...form, website: e.target.value})} margin="normal" />
          <TextField fullWidth label="Anschrift" value={form.anschrift} onChange={(e) => setForm({...form, anschrift: e.target.value})} margin="normal" multiline rows={2} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Abbrechen</Button>
          <Button onClick={handleSave} variant="contained" sx={{ bgcolor: '#1B5E20' }}>Speichern</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FoerdergeberPage;
